module.exports = __webpack_public_path__ + "static/img/chakanjietu.2a5032c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/chakanjietu.png
// module id = IWbc
// module chunks = 24